/* eslint-disable */
// import lib(s)
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Table, Radio } from 'antd';
import moment from 'moment';
import _ from 'lodash';
import styles from './EnrolledPatientResultTable.css'
import CustomTableComponent from '../Common/Table/CustomTableComponent'
import TableHeader from '../Common/Table/TableHeader';
import Grid from '@material-ui/core/Grid';
import history from '../../../legacy/containers/History';
import { ROUTES } from '../../../legacy/constants';
import {fetchEnrolledPatientData, newPatientEnrollForm} from '../../state/PatientEnrollment/PatientEnrollmentActions'
import DescriptiveToolTip from '../../../legacy/components/DescriptiveToolTip';



const Input = () => <input className={styles.testInput} type="text" />

const EnrolledPatientResultTable = () => {

    const dispatch = useDispatch();

     const searchResult = useSelector(state => state.idtfPatientEnrollment.patientEnrollment.searchResult);
 
     const [selectedRowKeys, setSelectedRowKeys] = useState(false);
     const [selectedPatient, setSelectedPatient] = useState({});
     const [displayDeterminationToolTip, setDisplayDeterminationToolTip] = useState(false);
     const [selectedData, setSelectedData] = useState({});


     

    //  const onChangeRadio =(e, record, index)=> {
         
    //      for (const x of data) {
    //          if(x.key === record.key){
    //              x.radioCheck = e.target.checked
    //          } else {
    //             x.radioCheck =  false
    //          }
             
    //      }
    //      setData([...data])
    // }


    // useEffect(() => {
    // console.log("final data", data);
    // }, [data])

    const getTableColumns = [
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="Last Name"
              keyMap="last_name"
              enableFilterRow={false}
              enableFilter={false}
              filterFunction={() => filterChange()}
              sortOrder={sortOrder}
              sortColumn={sortColumn}
              headerEnrollTable ={true}
            />
          );
        },
        dataIndex: 'last_name',
        key: 'last_name',
        // width: 100,
        sorter: (a, b) => a.last_name && a.last_name.localeCompare(b.last_name),
        render: (text, record, index) => {
          // if (text) {
          //   return <Radio checked={record.radioCheck}  key={index} >{text}</Radio>;
          // }
          const data = record.last_name && `${record.last_name}`;
          return (
            <p>
              {data}
            </p>
          );
        },
      },
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="Fisrt Name"
              keyMap="first_name"
              enableFilterRow={false}
              enableFilter={false}
              filterFunction={() => filterChange()}
              sortOrder={sortOrder}
              sortColumn={sortColumn}
            />
          );
        },
        dataIndex: 'first_name',
        key: 'first_name',
        // width: 100,
        sorter: (a, b) => a.first_name && a.first_name.localeCompare(b.first_name),
        render: (text, record, index) => {
          const data = record.first_name && `${record.first_name}`;
          return (
            <p>
              {data}
            </p>
          );
        },
      },
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="MRN"
              keyMap="mrn"
              enableFilterRow={false}
              enableFilter={false}
              filterFunction={() => filterChange()}
              sortOrder={sortOrder}
              sortColumn={sortColumn}
              headerEnrollTable ={true}
            />
          );
        },
        dataIndex: 'mrn',
        key: 'mrn',
        // width: 100,
        sorter: (a, b) => a.mrn && a.mrn.localeCompare(b.lastName),
        render: (text, record, index) => {
          const data = record.mrn && `${record.mrn}`;
          return (
            <p>
              {data}
            </p>
          );
        },
      },
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="SSN"
              keyMap="ssn_last_4_digit"
              enableFilterRow={false}
              enableFilter={false}
              filterFunction={() => filterChange()}
              sortOrder={sortOrder}
              sortColumn={sortColumn}
              headerEnrollTable ={true}
            />
          );
        },
        dataIndex: 'ssn_last_4_digit',
        key: 'ssn_last_4_digit',
        // width: 100,
        sorter: (a, b) => a.ssn_last_4_digit && a.ssn_last_4_digit.localeCompare(b.ssn_last_4_digit),
        render: (text, record, index) => {
          let data = record.ssn_last_4_digit && `${record.ssn_last_4_digit}`;
          data = data ?  `***-**-${data}` : '--';
           // data = data &&  `***-**-${data.substring(data.length - 4, data.length)}`
          return (
            <p>
              {data}
            </p>
          );
        },
      },
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="Date of Birth"
              keyMap="dob"
              enableFilterRow={false}
              enableFilter={false}
              filterFunction={() => filterChange()}
              sortOrder={sortOrder}
              sortColumn={sortColumn}
              headerEnrollTable ={true}
            />
          );
        },
        dataIndex: 'dob',
        key: 'dob',
        // width: 100,
        sorter: (a, b) => a.dob && a.dob.localeCompare(b.dob),
        render: (text, record, index) => {
          let data = record.dob && `${record.dob}`;
          data = moment(data).format('MM-DD-YYYY')
          return (
            <p>
              {data}
            </p>
          );
        },
      },
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="Enrollment Status"
              keyMap="dob"
              enableFilterRow={false}
              enableFilter={false}
              filterFunction={() => filterChange()}
              sortOrder={sortOrder}
              sortColumn={sortColumn}
              headerEnrollTable ={true}
            />
          );
        },
        dataIndex: 'dob',
        key: 'dob',
        // width: 100,
        sorter: (a, b) => a.dob && a.dob.localeCompare(b.dob),
        render: (text, record, index) => {
          const data = 'NA'
          return (
            <p>
            {
                 <button type="button"
                 onClick={() => RevokeButtonClick(record) }
                 className={(record.connection_status.toLowerCase() === 'expired' || record.connection_status.toLowerCase() === 'completed' || record.connection_status.toLowerCase() === 'complete') ? styles.PrimaryButtonDisabled : styles.PrimaryButton}
                // disabled={patientEnrollmentFormErrorState} 
                  >
                REVOKE
                </button>
              }
              {
                  displayDeterminationToolTip &&
                  selectedData.id === record.id && (
                    <DescriptiveToolTip
                      cssForEnroll = {true}
                      handleClose={handleToolTipClose}
                      bodyContent={() => (
                        <React.Fragment>
                          {"Call 1-833-525-1400 to Revoke or Early Teminate"}
                        </React.Fragment>
                      )}
                    />
                  )
              }
            </p>
          );
        },
      },
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="Re-Enroll"
              keyMap="dob"
              enableFilterRow={false}
              enableFilter={false}
              filterFunction={() => filterChange()}
              sortOrder={sortOrder}
              sortColumn={sortColumn}
              headerEnrollTable ={true}
            />
          );
        },
        dataIndex: 'dob',
        key: 'dob',
        // width: 100,
        sorter: (a, b) => a.dob && a.dob.localeCompare(b.dob),
        render: (text, record, index) => {
          const data = record.dob && `${record.dob}`;
          return (
            <p>
              {
                 <button type="button"
                 onClick={() => dispatch(fetchEnrolledPatientData(record && record.id)) }
                 className={ !(record.connection_status.toLowerCase() === 'expired' || record.connection_status.toLowerCase() === 'completed' || record.connection_status.toLowerCase() === 'complete') ? styles.PrimaryButtonDisabled : styles.PrimaryButton}
                // disabled={!(record.connection_status === 'expired')} 
                  >
                RE-ENROLL
                </button>
              }
            </p>
          );
        },
      },
      ];

      // click on table Re-enroll button
      const ReEnrollButtonClick = () => {

      }

      // click on table Revoke button
      const RevokeButtonClick = (record) => {
        setDisplayDeterminationToolTip(true)
        setSelectedData(record)
     
        // e.stopPropagation();

      }
      
    // Row clicked
    const clickedRow = (rowData, rowIndex) => {
        // for (const x of data) {
        //     if(x.key === rowData.key){
        //         x.radioCheck = true
        //     } else {
        //        x.radioCheck =  false
        //     }
            
        // }
        // setData([...data])
        setSelectedPatient(rowData)
   }

   // new patient enroll button click
   const handleButtonClick = () => {
    dispatch(newPatientEnrollForm())
   }

   const handleToolTipClose = e => {
    setDisplayDeterminationToolTip(false)
    setSelectedData({})
    e.stopPropagation();
  };

    return (
        <div className={styles.pageContainer}>
            <h1 className={styles.title}>Select Patient </h1>
            <Grid style={{marginBottom: 30, marginTop: -11, width: '12%' }} item xs={2}>
            <button type="button"
             onClick={ handleButtonClick }
            // className={ _.isEmpty(selectedPatient) ? styles.PrimaryButtonDisabled : styles.PrimaryButton}
            className={styles.PrimaryButton}
            // disabled={patientEnrollmentFormErrorState} 
                        >
            NEW PATIENT
            </button>
              </Grid>
            <Grid container spacing={5}>
                {/* ============= Start of Grid ============= */}
                {/* Basic Details section */}
                <Grid item xs={12}>
                <CustomTableComponent
                    columns={getTableColumns}
                    data={searchResult}
                    clickedRow={clickedRow}
                    cssProps= {true}
                />
                    {/* <Input /> */}
                </Grid>
                <Grid item xs={10}>
                    {/* Empty space as per figma */}
                </Grid>
                <Grid item xs={2}>
                {/* <button type="button"
                        className={ _.isEmpty(`selectedPatient`) ? styles.PrimaryButtonDisabled : styles.PrimaryButton}
                        // disabled={patientEnrollmentFormErrorState} 
                        >
                      SELECT PATIENT
                    </button> */}
                </Grid>
                {/* ============= End of Grid ============= */}
            </Grid>

        </div>
      )
}

export default EnrolledPatientResultTable



// WEBPACK FOOTER //
// ./src/views/components/EnrolledPatientResultTable/EnrolledPatientResultTable.jsx